import { doc, getDocs, query, where } from "firebase/firestore";
import { AdminsTableRef, auth } from "../../firebase";

//get current admin/user
export const getCurrentUser = async () => {
  // Check if auth.currentUser exists before accessing uid
  if (!auth.currentUser) {
    throw new Error("No authenticated user found");
  }
  
  const userID = auth.currentUser.uid;
  const queryRef = query(AdminsTableRef, where("userId", "==", userID));
  return await getDocs(queryRef);
};
